import { AdminSpinner } from '@vgrubs/components';
import { useLayoutEffect, useRef, useState } from 'react';
import { Overlay, SpinnerSpot } from './ListFetchingOverlay.styled';

const SPINNER_SIZE = 100;

/**
 * Fades a list while another filter's rows load, like AdminSpinner's
 * absolute overlay, but keeps the spinner in the middle of the part of the
 * list that is on screen: the list can be far taller than the screen, and
 * centred on the list the spinner sat out of view.
 *
 * Placed by hand, not with position: sticky - the admin <main> clips with
 * overflow: hidden, which turns sticky off for everything inside it.
 */
export const ListFetchingOverlay = () => {
  const overlayRef = useRef<HTMLDivElement>(null);
  const [top, setTop] = useState(0);

  useLayoutEffect(() => {
    const place = () => {
      const box = overlayRef.current?.getBoundingClientRect();
      if (!box) return;
      const middle = window.innerHeight / 2 - box.top - SPINNER_SIZE / 2;
      setTop(Math.max(0, Math.min(middle, box.height - SPINNER_SIZE)));
    };
    place();
    window.addEventListener('scroll', place, { passive: true });
    window.addEventListener('resize', place);
    return () => {
      window.removeEventListener('scroll', place);
      window.removeEventListener('resize', place);
    };
  }, []);

  return (
    <Overlay ref={overlayRef}>
      <SpinnerSpot style={{ top }}>
        <AdminSpinner small noOverlay $noBackground />
      </SpinnerSpot>
    </Overlay>
  );
};
